module.exports = __webpack_public_path__ + "img/40_69_014_580.cd3592c1.jpg";